import React from 'react';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Row, Col } from 'reactstrap';

import * as rutinasActions from 'modules/rutinas/action';

/*
Props:
rutina
*/
@connect((store) => ({
  userRoles: store.getIn(['user', 'roles']),
}))
export default class extends React.Component {
  delete = (id) => this.props.dispatch(rutinasActions.setState({ eliminarId: id }));
  add = (rutina) => this.props.dispatch(push('/dashboard/rutinas/add/' + rutina.get('id')));
  render() {
    let { rutina, userRoles } = this.props;
    return (
      <MaterialUI.ListItem
        className="ptb-5 center_on_phone"
        innerDivStyle={{ paddingRight: 105 }}
        rightIconButton={
          userRoles &&
          userRoles.find((v) => v == 'admin' || v == 'devAdmin' || v == 'administrador_rutinas') && (
            <MaterialUI.FlatButton icon={<FontAwesome name="trash" />} onTouchTap={this.delete.bind(this, rutina.get('id'))} className="listIcon red" />
          )
        }
        primaryText={
          <Row onClick={this.add.bind(this, rutina)}>
            <Col md="3" className="textLeft center_on_phone">
              <FontAwesome className="ml-30" key={rutina.get('id') + 'f'} name="clock-o" />
              <span key={rutina.get('id') + 's'} style={{ fontSize: 20 }} className="ml-10">
                {rutina.get('horario')}{' '}
              </span>
            </Col>
            <Col md="5" className="textLeft center_on_phone">
              <FontAwesome key={rutina.get('id') + 'rewe'} name="map-o" />
              <span key={rutina.get('id') + 'h'} className="ml-10">
                {rutina.getIn(['_trayecto', 'subnombre']) ? rutina.getIn(['_trayecto', 'nombre']) + ' - ' + rutina.getIn(['_trayecto', 'subnombre']) : rutina.getIn(['_trayecto', 'nombre'])}{' '}
              </span>
            </Col>
            <Col md="2" className="textLeft center_on_phone">
              {rutina.get('domingo') && 'D '}
              {rutina.get('lunes') && 'L '}
              {rutina.get('martes') && 'M '}
              {rutina.get('miercoles') && 'Mi '}
              {rutina.get('jueves') && 'J '}
              {rutina.get('viernes') && 'V '}
              {rutina.get('sabado') && 'S '}
              {rutina.get('feriado') && 'F '}
            </Col>
            <Col md="2">
              <FontAwesome className="ml-30" key={rutina.get('id') + 'i'} name="users" />
              <span key={rutina.get('id') + 'j'}> {rutina.get('cantAsientos')} </span>
            </Col>
          </Row>
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// src/modules/rutinas/components/itemList.js